/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { USBGrid, USBColumn } from '@usb-shield/react-grid'
import USBButton from '@usb-shield/react-button'
import { PropTypes } from 'prop-types'
import ShieldInput from '../../components/atoms/ShieldInput/ShieldInput'
import { loginFieldsSchema } from '../../utils/FieldsUtility'

/**
 * LoginComponent page
 */
/*
<a
            href="#"
            style={{ marginTop: '10px' }}
            className="subtle bluebar-menuitem"
            onClick={() => {
              recoveryHandler()
            }}
          >
            Forgot your password?
          </a>
*/
const LoginComponent = ({
  loginHandler,
  clearHandler,
  fieldsState = {},
  setFieldState,
  onSensitiveValueChange,
  credentialResetCounter
}) => {
  /**
   * Triggers when user clicks enter button on keyboard
   */
  const onKeyPress = e => {
    if (e.charCode === 13) {
      loginHandler()
    }
  }

  return (
    <>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <ShieldInput
            fieldSchema={loginFieldsSchema.companyId}
            fieldState={fieldsState.companyId ? fieldsState.companyId : { id: 'companyId', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            addClasses="input-darkbg"
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <ShieldInput
            fieldSchema={loginFieldsSchema.userId}
            fieldState={fieldsState.userId ? fieldsState.userId : { id: 'userId', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            addClasses="input-darkbg"
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={15} addClasses="column">
          <ShieldInput
            fieldSchema={loginFieldsSchema.credential}
            fieldState={fieldsState.credential ? fieldsState.credential : { id: 'credential', value: '', isError: false, isUserExistsError: false, isFocused: false }}
            setFieldState={setFieldState}
            onSensitiveValueChange={onSensitiveValueChange}
            onKeyPress={e => onKeyPress(e)}
            resetCounter={credentialResetCounter}
            addClasses="input-darkbg"
          />
        </USBColumn>
      </USBGrid>
      <USBGrid gridGap="large" addClasses="PageGrid">
        <USBColumn largeSpan={16} addClasses="column">
          <div>
            <USBButton
              type="button"
              variant="loud"
              // size="small"
              ariaLabel="clear"
              id="btnClearUser"
              name="btnClearUser"
              dataTestId="btnClearUser"
              handleClick={() => clearHandler()}
            >
              Clear
            </USBButton>
            <USBButton
              id="btnlogin"
              variant="primary"
              type="button"
              handleClick={loginHandler}
              addClasses="noleftmargin"
            >
              Log In
            </USBButton>
          </div>
        </USBColumn>
      </USBGrid>
    </>
  )
}

LoginComponent.propTypes = {
  fieldsState: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
      isError: PropTypes.bool.isRequired,
      isUserExistsError: PropTypes.bool,
      isFocused: PropTypes.bool.isRequired
    })
  ).isRequired,
  setFieldState: PropTypes.func.isRequired,
  clearHandler: PropTypes.func.isRequired,
  loginHandler: PropTypes.func.isRequired,
  onSensitiveValueChange: PropTypes.func.isRequired,
  credentialResetCounter: PropTypes.number.isRequired
}

export default LoginComponent
